var _ = require('underscore');
var Section = require('submissions/pages/Section/Section');

require('./Help.less');

var Banner = require('submissions/components/Banner/Banner');


module.exports = Section.extend({

    el: '.Help',

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'Banner': {selector: '.Banner', viewConstructor: Banner}
    },

    events: {
    },


    initialize: function (options) {
        this.options = options || {};

        Section.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/pages/Help/Help.js
// module id = 131
// module chunks = 0